import { LucideProps } from 'lucide-react';

export const ArrowRightIcon = (props: LucideProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33301 10H16.6663M16.6663 10L11.6663 5M16.6663 10L11.6663 15"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
